import { useEffect, useState } from "react";
import ProjetsMatchesDashboard from "../ProjetsMatchesDashboard";
import ProjectsDashboard from "../ProjectsDashboard";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTabProjet } from "../../redux/actions/dashboardActions";
import "./styles.css";
import ProjectsRealisedPrestataireDashboard from "../ProjectsRealisedPrestataireDashboard";
import SearchProjets from "../SearchProjets";
import LikesReceivedDashboard from "../LikesReceivedDashboard";
import LikesSentDashboard from "../LikesSendDashboard";
const MesProjetsDashboard = () => {
    const { selectedMatch } = useSelector((state) => state.match);
    const { activeTabProjet } = useSelector((state) => state.dashboard);
    const { selectedProposition } = useSelector((state) => state.proposition);
    const { user } = useSelector((state) => state.auth);
    const { activeSubscription } = useSelector(state => state.subscriptionOffer);
    const nbCreditsLikes = user?.profilPrestataire?.creditLikesStandard ?? 0;

    const [menuOpen, setMenuOpen] = useState(false);
    const dispatch = useDispatch();
    const tabStyle = (tab) => ({
        padding: "10px 18px",
        cursor: "pointer",
        borderBottom: activeTabProjet === tab ? "3px solid #007bff" : "3px solid transparent",
        fontWeight: activeTabProjet === tab ? "bold" : "normal"
    });


    const getActiveTabName = () => {
        switch (activeTabProjet) {
            case "trouver":
                return "Trouver un projet";
            case "likesReceived":
                return "Demandes de matchs reçues";
            case "likesSent":
                return "Demandes de matchs envoyées";
            case "confirmes":
                return "Matchs confirmés";
            case "projectsRealised":
                return "Projets terminés"
            default:
                dispatch(setActiveTabProjet("trouver"));
                return "Trouver un projet";
        }
    }


    useEffect(() => {
        if (selectedMatch !== null && selectedProposition === null) {
            dispatch(setActiveTabProjet("confirmes"));
        }
    }, [selectedMatch, selectedProposition]);

    return (
        <div>
            {!selectedMatch && (<h2 style={{ textAlign: "center", margin: "10px" }}>Prospection</h2>)}
            {!activeSubscription && (
                <p>Likes restants : {nbCreditsLikes}</p>
            )}
            {/* ======== 🍔 BOUTON BURGER MOBILE ======== */}
            <button className="burger-btn" onClick={() => setMenuOpen(!menuOpen)}>
                {getActiveTabName()}<span>{menuOpen ? "▲" : "▼"}</span>
            </button>

            {/* ======== 🍔 MENU BURGER OUVERT ======== */}
            {menuOpen && (
                <div className="burger-menu">
                    <div className="burger-item" onClick={() => { dispatch(setActiveTabProjet("trouver")); setMenuOpen(false) }}>Trouver un projet</div>
                    <div className="burger-item" onClick={() => { dispatch(setActiveTabProjet("likesReceived")); setMenuOpen(false) }}>Demandes de matchs reçues</div>
                    <div className="burger-item" onClick={() => { dispatch(setActiveTabProjet("likesSent")); setMenuOpen(false) }}>Demandes de matchs envoyées</div>
                    <div className="burger-item" onClick={() => { dispatch(setActiveTabProjet("confirmes")); setMenuOpen(false) }}>Matchs confirmés</div>
                    <div className="burger-item" onClick={() => { dispatch(setActiveTabProjet("projectsRealised")); setMenuOpen(false) }}>Projets réalisés</div>
                </div>
            )}
            {/* Onglets */}
            {!selectedMatch && (<div className="desktop-menu">
                <div style={tabStyle("trouver")} onClick={() => dispatch(setActiveTabProjet("trouver"))}>Trouver un projet</div>
                <div style={tabStyle("likesReceived")} onClick={() => dispatch(setActiveTabProjet("likesReceived"))}>Demandes de matchs reçues</div>
                <div style={tabStyle("likesSent")} onClick={() => dispatch(setActiveTabProjet("likesSent"))}>Demandes de matchs envoyées</div>
                <div style={tabStyle("confirmes")} onClick={() => dispatch(setActiveTabProjet("confirmes"))}>Matchs confirmés</div>
                <div style={tabStyle("projectsRealised")} onClick={() => dispatch(setActiveTabProjet("projectsRealised"))}>Projets réalisés</div>
            </div>)}

            {/* Contenus dynamiques */}
            {activeTabProjet === "trouver" && <SearchProjets />}
            {activeTabProjet === "likesReceived" && <LikesReceivedDashboard/>}
            {activeTabProjet === "likesSent" && <LikesSentDashboard/>}
            {activeTabProjet === "confirmes" && <ProjetsMatchesDashboard />}
            {activeTabProjet === "projectsRealised" && <ProjectsRealisedPrestataireDashboard />}
        </div>
    );
};

export default MesProjetsDashboard;
